import { Link } from 'react-router-dom'
import { SqueezeCarousel } from './ui/carousel-squeeze'
import { PROJECTS } from '../data/projects'

const mark = (text) => (
  <span style={{ fontFamily: 'Geist Variable, sans-serif', fontWeight: 600, fontSize: 14, color: '#fff', letterSpacing: '-0.01em' }}>
    {text}
  </span>
)

const SLIDES = PROJECTS.map(({ id, name, description, image, srcSet, imageAlt, href }) => ({
  id, title: `${name}.`, description, image, srcSet, imageAlt,
  overlay: mark(name), action: 'Visit site', href, target: '_blank',
}))

const SERVICES = ['React & Next.js', 'Tailwind CSS', 'Node.js', 'REST & GraphQL', 'Stripe & Payments', 'SEO-ready']

export default function WebPortfolio() {
  return (
    <section
      id="web"
      style={{ background: '#000', position: 'relative', overflow: 'hidden' }}
      className="py-20 md:py-32 px-4 md:px-8"
    >
      {/* Background glow */}
      <div style={{
        position: 'absolute', width: 600, height: 400,
        top: '10%', left: '50%', transform: 'translateX(-50%)',
        background: 'radial-gradient(ellipse, rgba(6,182,212,0.06) 0%, transparent 65%)',
        filter: 'blur(60px)', pointerEvents: 'none',
      }} />

      {/* Section label */}
      <div className="flex flex-col items-center text-center mb-12 md:mb-16 relative z-10">
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          marginBottom: 20, padding: '5px 14px 5px 10px',
          background: 'rgba(6,182,212,0.06)', border: '1px solid rgba(6,182,212,0.18)',
          borderRadius: 999,
        }}>
          <div style={{
            width: 6, height: 6, borderRadius: '50%',
            background: '#06b6d4', boxShadow: '0 0 10px #06b6d4',
          }} />
          <span style={{
            fontSize: 11, color: 'rgba(255,255,255,0.5)',
            letterSpacing: '.13em', textTransform: 'uppercase',
            fontFamily: 'Geist Variable, sans-serif',
          }}>
            Web Development
          </span>
        </div>

        <h2 style={{
          fontFamily: 'Geist Variable, sans-serif',
          fontSize: 'clamp(32px, 5vw, 64px)',
          fontWeight: 800, color: '#fff',
          letterSpacing: '-0.035em', lineHeight: 1.05,
          marginBottom: 16,
        }}>
          Sites that actually<br />
          <span style={{ color: '#06b6d4' }}>perform.</span>
        </h2>

        <p style={{
          fontSize: 15, color: 'rgba(255,255,255,0.5)',
          lineHeight: 1.8, maxWidth: 460,
          fontFamily: 'Geist Variable, sans-serif',
        }}>
          We design and build fast, clean websites and web apps — landing pages, SaaS products, e-commerce stores, dashboards, and everything in between. No templates. All custom.
        </p>

        {/* Tech tags */}
        <div className="flex flex-wrap justify-center gap-2 mt-6">
          {SERVICES.map(s => (
            <span key={s} style={{
              padding: '4px 14px', borderRadius: 999, fontSize: 11,
              color: 'rgba(6,182,212,0.8)', background: 'rgba(6,182,212,0.08)',
              border: '1px solid rgba(6,182,212,0.22)',
              fontFamily: 'Geist Variable, sans-serif', fontWeight: 500,
              letterSpacing: '0.02em',
            }}>
              {s}
            </span>
          ))}
        </div>
      </div>

      {/* Portfolio carousel */}
      <div className="relative z-10" style={{ maxWidth: '64rem', margin: '0 auto' }}>
        <SqueezeCarousel
          slides={SLIDES}
          label="Websites we've built"
          accent="#06b6d4"
          accentForeground="#04121a"
          height="clamp(220px, 34vw, 400px)"
          style={{
            '--foreground': '#ffffff',
            '--muted-foreground': 'rgba(255,255,255,0.55)',
            '--background': '#000000',
            '--muted': '#0c0c14',
          }}
        />
      </div>

      {/* CTA */}
      <div className="flex justify-center mt-12 md:mt-16 relative z-10">
        <Link
          to="/contact"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            padding: '13px 28px', borderRadius: 12, fontSize: 14,
            background: 'rgba(6,182,212,0.1)', color: '#22d3ee',
            border: '1px solid rgba(6,182,212,0.28)',
            fontFamily: 'Geist Variable, sans-serif', fontWeight: 600,
            textDecoration: 'none', transition: 'all 0.2s ease',
            letterSpacing: '-0.01em',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'rgba(6,182,212,0.18)'
            e.currentTarget.style.borderColor = 'rgba(6,182,212,0.5)'
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'rgba(6,182,212,0.1)'
            e.currentTarget.style.borderColor = 'rgba(6,182,212,0.28)'
          }}
        >
          Start a project
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </section>
  )
}
